import saasrequest from '@/utils/saasrequest'
import cryptoJs from 'crypto-js'
// ""中与后台一样
import {getProductLineToken} from '@/utils/auth'
const KEY = cryptoJs.enc.Utf8.parse('12345678901234567890123456789000')// ""与后台一样  Key
const IV = cryptoJs.enc.Utf8.parse('1234567890123456')
// const ProductLineGUID = '5bf44d14-bf53-4e0f-becb-b21b7fe1ee71'// 产品线

export function Post (service, action, data) {
  if (typeof (data) === 'undefined') {
    data = {}
  }
  data['ProductLineGUID'] = getProductLineToken()
  return saasrequest({
    url: '/' + service + '/' + aes('api/admin/' + action),
    //  url: '/' + aes('api/admin/' + action),
    method: 'post',
    data: aes(data)
  })
}

export function Get (service, action, QueryString) {
  var geturl = 'api/admin/' + action + '/' + getProductLineToken() + '/' + QueryString
  if (typeof (QueryString) === 'undefined') {
    geturl = 'api/admin/' + action
  }
  if (QueryString === '') {
    geturl = 'api/admin/' + action + '/' + getProductLineToken()
  }
  return saasrequest({
    url: '/' + service + '/' + aes(geturl),
    //url: '/' + aes(geturl),
    method: 'get'
  })
}

export function Put (service, action, QueryString, data) {
  if (typeof (data) === 'undefined') {
    data = {}
  }
  data['ProductLineGUID'] = getProductLineToken()
  var geturl = 'api/admin/' + action + '/' + QueryString
  if (typeof (QueryString) === 'undefined') {
    geturl = 'api/admin/' + action
  }
  return saasrequest({
    url: '/' + service + '/' + aes(geturl),
    //url: '/' + aes(geturl),
    method: 'put',
    data: aes(data)
  })
}

export function Delete (service, action, QueryString) {
  var geturl = 'api/admin/' + action + '/' + getProductLineToken() + '/' + QueryString
  if (typeof (QueryString) === 'undefined') {
    geturl = 'api/admin/' + action
  }
  return saasrequest({
    url: '/' + service + '/' + aes(geturl),
    //url: '/' + aes(geturl),
    method: 'delete'
  })
}

function aes (word) {
  let key = KEY
  let iv = IV
  let srcs = ''
  if (typeof word === 'string') {
    srcs = word
  } else if (typeof word === 'object') {
    srcs = JSON.stringify(word)
  }
  var encrypted = cryptoJs.AES.encrypt(srcs, key, {
    iv: iv,
    mode: cryptoJs.mode.CBC, // 使用偏移量
    padding: cryptoJs.pad.Pkcs7
  })

  let result = cryptoJs.enc.Hex.stringify(encrypted.ciphertext)
  return result
}



// WEBPACK FOOTER //
// ./src/api/saasapi.js